var _rect, _rect2, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagramIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 10,
    fill: "#181818"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 41,
    height: 41,
    rx: 9.5,
    stroke: "#A8A8A8",
    strokeOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4901 16.1816C18.5512 16.1816 16.1719 18.5635 16.1719 21.4998C16.1719 24.4387 18.5537 26.818 21.4901 26.818C24.429 26.818 26.8082 24.4361 26.8082 21.4998C26.8082 18.5609 24.4264 16.1816 21.4901 16.1816ZM21.4901 24.9517C19.5823 24.9517 18.0382 23.4067 18.0382 21.4998C18.0382 19.5929 19.5832 18.0479 21.4901 18.0479C23.3969 18.0479 24.942 19.5929 24.942 21.4998C24.9428 23.4067 23.3978 24.9517 21.4901 24.9517Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8297 11.066C23.8977 10.9758 19.1123 10.9802 17.1786 11.066C15.4793 11.1456 13.9804 11.556 12.7721 12.7643C10.7526 14.7838 11.0107 17.505 11.0107 21.4958C11.0107 25.5802 10.7832 28.2384 12.7721 30.2273C14.7994 32.2537 17.5601 31.9886 21.5037 31.9886C25.5497 31.9886 26.9462 31.9912 28.3768 31.4374C30.322 30.6822 31.7902 28.9436 31.9337 25.8208C32.0247 23.888 32.0195 19.1036 31.9337 17.1699C31.7605 13.4835 29.7821 11.248 25.8297 11.066ZM28.8878 28.8911C27.564 30.215 25.7273 30.0969 21.4783 30.0969C17.1033 30.0969 15.3489 30.1616 14.0688 28.878C12.5944 27.4107 12.8613 25.0543 12.8613 21.4818C12.8613 16.6475 12.3652 13.1659 17.2171 12.9174C18.3318 12.8781 18.66 12.8649 21.4661 12.8649L21.5055 12.8912C26.1683 12.8912 29.8267 12.4029 30.0463 17.2539C30.0962 18.3607 30.1076 18.6932 30.1076 21.4949C30.1067 25.8191 30.189 27.5839 28.8878 28.8911Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2351 16.9997C27.9129 16.9997 28.4624 16.4502 28.4624 15.7724C28.4624 15.0946 27.9129 14.5452 27.2351 14.5452C26.5573 14.5452 26.0078 15.0946 26.0078 15.7724C26.0078 16.4502 26.5573 16.9997 27.2351 16.9997Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramIcon);
export default __webpack_public_path__ + "static/media/instagram_icon.5916c41437a13de28384772eec7a7601.svg";
export { ForwardRef as ReactComponent };